import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/system';
import { Box, Divider, Tooltip, Typography } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export default function FileInputCard({ question }) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        px={2}
        justifyContent="space-between"
        gap={2}
      >
        <Typography
          variant="subtitle1"
          sx={{
            mb: 0.5,
            fontSize: isSmallScreen ? '0.8rem' : '1rem',
            fontWeight: 'bold',
            flex: 1,
            minWidth: 200,
            wordBreak: 'break-word',
          }}
        >
          {question.questionText}
        </Typography>

        <Typography
          variant="caption"
          color="info.dark"
          sx={{ whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
        >
          {t('surveyDashboard.fileInput')}
        </Typography>
      </Stack>

      <Tooltip
        title={
          <Stack fullWidth spacing={0.5} sx={{ overflowY: 'auto' }} maxHeight={500}>
            {question.responses.map((response, idx) => {
              const isLast = idx === question.responses.length - 1;
              return (
                <Box key={idx}>
                  <Typography variant="caption">{response}</Typography>
                  {!isLast && <Divider sx={{ mt: 1, bgcolor: 'ghostwhite' }} />}
                </Box>
              );
            })}
          </Stack>
        }
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: '28px',
            fontWeight: 'bold',
          }}
        >
          {question.responses.length}
        </Typography>
      </Tooltip>
      <Typography
        variant="body2"
        sx={{
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'lighter',
        }}
      >
        {t('surveyDashboard.totalFilesUploaded')}
      </Typography>
    </Box>
  );
}

FileInputCard.propTypes = {
  question: PropTypes.object,
};
